module.exports = __webpack_public_path__ + "assets/link.ab816f6b.svg";